import React, { useContext, useEffect, useRef, useState } from 'react';
import './assets/css/IBLUserProfile.css';
import { IoChevronDownSharp } from 'react-icons/io5';
import { getImageUrl, getTenant, handleLogout } from '../../hooks/helpers';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
import { getGravatarUrl } from 'react-awesome-gravatar';
import { TbUser } from 'react-icons/tb';
import { useDebounce } from '../../hooks/useDebounce';
import { LuLayoutDashboard, LuLogOut } from 'react-icons/lu';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';
import { GoOrganization } from 'react-icons/go';
import { Account } from '../account';
import { IBLModalLoader } from '../IBLModalLoader';
import { AppDataContext, isJSON } from '../../utils';
import styled from 'styled-components';

const DEFAULT_TENANT = 'main';
const STATIC_PAGES_ENABLED = process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED === 'true';

interface IBLUserProfileProps {
  color?: string;
  profileImageSize?: number;
  className?: string;
  profileMenuTo?: string;
  showProfileMenu?: boolean;
  showSettingsMenu?: boolean;
  showLogoutMenu?: boolean;
  additionalDropdowns?: { icon: any, label: string }[];
  backgroundColor?: string;
  hoverColor?: string;
}


export const IBLUserProfile: React.FC<IBLUserProfileProps> = ({
                                                                color = '#000',
                                                                backgroundColor = '#FFF',
                                                                hoverColor = '#ededed',
                                                                profileImageSize = 35,
                                                                additionalDropdowns = [],
                                                                className = '',
                                                                showProfileMenu = true,
                                                                profileMenuTo = '/profile/activity',
                                                                showSettingsMenu = true,
                                                                showLogoutMenu = true,
                                                                ...rest
                                                              }) => {

  const { appData, setAppData } = useContext(AppDataContext);
  const [profileImgURL, setprofileImgURL] = useState('');
  const [logoutStarted, setLogoutStarted] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [accountBoxFocused, setAccountBoxFocused] = useState(false);
  const [actualTenant, setActualTenant] = useState('');
  const [allTenants, setAllTenants] = useState([])
  const [inactiveTenants, setInactiveTenants] = useState([])
  const tenantMenuRef = useRef(null)

  useEffect(() => {
    if (Object.keys(appData.userData || {}).length > 0) {
      setIsLoggedIn(true);
      if (!!appData.userMetaData?.profile_image?.has_image) {
        setprofileImgURL(getImageUrl(appData.userMetaData?.profile_image?.image_url_full));
      } else {
        const gravatarURL = getGravatarUrl(appData.userData?.user_email, {
          default: '404',
          size: profileImageSize,
          defaultUrl: appData.userMetaData?.profile_image?.image_url_full,
        });
        //If gravatar img doesn't exist for user email
        if (String(gravatarURL).includes('default=404')) {
          setprofileImgURL(getImageUrl(appData.userMetaData?.profile_image?.image_url_full));
        } else {
          setprofileImgURL(gravatarURL);
        }
      }
    }
  }, [appData.userData, appData.userMetaData]);

  useEffect(() => {
    const userTenant = getTenant();
    const tenants = isJSON(localStorage.getItem('tenants')) ? JSON.parse(localStorage.getItem('tenants')) : []
    const tenantsList = Array.isArray(tenants) ? tenants : []
    setAllTenants(tenantsList)
    const inactiveTenantsList = tenantsList.filter((pre)=>pre.key !== userTenant)
    setInactiveTenants(inactiveTenantsList)
    if (inactiveTenantsList.length > 0) {
      setActualTenant(userTenant);
    }
  }, []);

  const handleUserProfileHover = () => {
    $(document).on('click', '.ibl-user-profile-container, .ibl-menu-dropdown-tenant-link', function() {
      $(this).children('.ibl-menu-dropdown-container').addClass('open');
    });

    /*$(document).on('click', '.ibl-menu-dropdown-tenant-link', function() {
      const childTarget = $(this).children('.ibl-menu-dropdown-container')
      if(childTarget.attr('data-opened') !== "true"){
        childTarget.addClass('open');
        childTarget.attr('data-opened', 'true');
      }else{
        childTarget.removeClass('open');
        childTarget.attr('data-opened', 'false');
      }
    });*/

    //HIDING DROPDOWN WHEN CLICKING ELSEWHERE
    $(window).on('click', function(e) {
      if ($('.ibl-user-profile-container > .ibl-menu-dropdown-container.open:visible') && !$(e.target).closest('.ibl-user-profile-container').length) {
        $('.ibl-menu-dropdown-container:visible').removeClass('open');
      }
      /*if ($('.ibl-menu-dropdown-tenant-link .ibl-menu-dropdown-container.open:visible') && !$(e.target).closest('.ibl-menu-dropdown-tenant-link .ibl-menu-dropdown-container').length) {
        $('.ibl-menu-dropdown-tenant-link .ibl-menu-dropdown-container:visible').removeClass('open');
      }*/

    });
  };

  const handleTenantSwitch = (tenant) => {
    localStorage.setItem('tenant', tenant)
    localStorage.setItem('current_tenant', JSON.stringify(allTenants.find((pre)=>pre.key === tenant)))
    setInactiveTenants(allTenants.filter((pre)=>pre.key !== tenant))
    setActualTenant(tenant)
    tenantMenuRef.current.classList.remove("open")
  }

  useDebounce(handleUserProfileHover, 200, []);

  return (
    <>
      {
        isLoggedIn &&
        <div className={`ibl-user-profile-container ${className}`} {...rest} >
          {
            profileImgURL !== '' && (
              <img
                src={profileImgURL}
                alt={'IBL User Profile Image'}
                className="ibl-user-profile-img"
                style={{ height: `${profileImageSize}px` }}
              />
            )
          }
          <IoChevronDownSharp color={color} />
          <div className="ibl-menu-dropdown-container">
            <div className="ibl-menu-dropdown-block" style={{ color: color, backgroundColor: backgroundColor }}>
              {
                actualTenant !== '' && (
                  <NavLink aria-details={hoverColor} className={'ibl-menu-dropdown-link ibl-menu-dropdown-tenant-link'}
                           to={'#'}>
                    <GoOrganization size={18} color={color} />
                    <span>{actualTenant}</span>
                    {
                      //SHOW CHEVRON IF MORE THAN 1 TENANT
                      inactiveTenants.length > 0 && (
                        <>
                          <IoChevronDownSharp color={color} />
                          <div ref={tenantMenuRef} className={'ibl-menu-dropdown-container'}>
                            <div className={'ibl-menu-dropdown-block'}>
                              {
                                inactiveTenants.map((tenant)=> (
                                  <div onClick={()=>handleTenantSwitch(tenant.key)} className={'ibl-menu-dropdown-link'}>
                                    {tenant.key}
                                  </div>
                                ))
                              }
                            </div>
                          </div>
                        </>
                      )
                    }
                  </NavLink>
                )
              }
              {
                STATIC_PAGES_ENABLED &&
                <IBLDropdownLink
                  aria-details={hoverColor} className={'ibl-menu-dropdown-link'}
                  to={`/${process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED_DASHBOARD_PATH}`}>
                  <LuLayoutDashboard size={18} color={color} />
                  <span>Dashboard</span>
                </IBLDropdownLink>
              }
              {
                showProfileMenu && (
                  <IBLDropdownLink aria-details={hoverColor} className={'ibl-menu-dropdown-link'} to={profileMenuTo}>
                    <TbUser size={18} color={color} />
                    <span>Profile</span>
                  </IBLDropdownLink>
                )
              }
              {
                showSettingsMenu && (
                  <IBLDropdownLink aria-details={hoverColor} onClick={() => setAccountBoxFocused(true)}
                                   className={'ibl-menu-dropdown-link'} to={'#'}>
                    <HiOutlineCog6Tooth size={18} color={color} />
                    <span>Account</span>
                  </IBLDropdownLink>
                )
              }
              {
                Array.isArray(additionalDropdowns) && additionalDropdowns.length > 0 && additionalDropdowns.map(({
                                                                                                                   icon =
                                                                                                                     <LuLogOut
                                                                                                                       size={18}
                                                                                                                       color={color} />,
                                                                                                                   label = 'Menu',
                                                                                                                   ...rest
                                                                                                                 }) => (
                  <IBLDropdownLink aria-details={hoverColor} className={'ibl-menu-dropdown-link'} to={'#'} {...rest}>
                    {icon}
                    <span>{label}</span>
                  </IBLDropdownLink>
                ))
              }
              {
                showLogoutMenu && (
                  <IBLDropdownLink aria-details={hoverColor} onClick={() => {
                    setLogoutStarted(true);
                    handleLogout();
                  }} className={'ibl-menu-dropdown-link'} to={'#'}>
                    <LuLogOut size={18} color={color} />
                    <span>Log Out</span>
                  </IBLDropdownLink>
                )
              }
            </div>
          </div>
        </div>
      }
      {
        accountBoxFocused && <Account onModalClose={() => setAccountBoxFocused(false)} />
      }
      {
        logoutStarted && <IBLModalLoader displayText={'Log out in progress...'} />
      }
    </>
  )
    ;
};

const IBLDropdownLink = styled(NavLink)`
    &:hover {
        background-color: ${props => props?.['aria-details']};
    }
`;